module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-diversity idea"
  }, [_c('hero', {
    attrs: {
      "props": _vm.inclusionDetail.elements,
      "heroHome": false,
      "lightbox": false
    }
  }), _vm._v(" "), (_vm.inclusionDetail.elements) ? [(_vm.inclusionDetail.elements.intro_headline.value) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section col-xs-12 no-gutters",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v(_vm._s(_vm.inclusionDetail.elements.intro_headline.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.intro_paragraph.value)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "steps",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.intro_steps.value)
    }
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.inclusionDetail.elements) ? [(_vm.inclusionDetail.elements.sc_headline.value) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section sub-committe-container"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v(_vm._s(_vm.inclusionDetail.elements.sc_headline.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.sc_description.value)
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "transitionName": "fade"
    }
  }, _vm._l((_vm.inclusionDetail.elements.sub_committees
    .value), function(sub_committee, key) {
    return _c('tab', {
      key: key,
      staticClass: "sub-committes",
      attrs: {
        "title": _vm.modularContent[sub_committee].elements.tab_label.value
      }
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.modularContent[sub_committee].elements.image.value[0].url,
        "alt": "modularContent[sub_committee].elements.subcommittee.value"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('h3', [_vm._v("\n                    " + _vm._s(_vm.modularContent[sub_committee].elements.tab_label.value) + "\n                  ")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.modularContent[sub_committee].elements.description.value)
      }
    }), _vm._v(" "), (
      _vm.modularContent[sub_committee].elements.button_link != undefined &&
      _vm.modularContent[sub_committee].elements.button_link.value != ''
    ) ? [_c('a', {
      staticClass: "btn_orange",
      attrs: {
        "href": _vm.modularContent[sub_committee].elements.button_link.value,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.modularContent[sub_committee].elements.button_label.value))])] : _vm._e()], 2)])])])
  }), 1)], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.monthlyTopics.length > 0) ? [(_vm.inclusionDetail.elements.mt_headline.value) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section topics-section"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v(_vm._s(_vm.inclusionDetail.elements.mt_headline.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.mt_description.value)
    }
  }), _vm._v(" "), (_vm.monthlyTopics[0].elements) ? _c('div', {
    staticClass: "highlighted-topic"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.monthlyTopics[0].elements.image.value[0].url,
      "alt": _vm.monthlyTopics[0].elements.title.value
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "month-name"
  }, [_vm._v(_vm._s(_vm.getMonthString(_vm.monthlyTopics[0].elements.date.value)))]), _vm._v(" "), _c('span', {
    staticClass: "topic-name"
  }, [_vm._v(_vm._s(_vm.monthlyTopics[0].elements.title.value))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.monthlyTopics[0].elements.content.value)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTopics.length > 1) ? _c('div', {
    staticClass: "topics"
  }, _vm._l((_vm.monthlyTopics.slice(1)), function(topic, index) {
    return _c('div', {
      key: index,
      staticClass: "topic",
      attrs: {
        "id": 'c' + index
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "month-name"
    }, [_vm._v(_vm._s(_vm.getMonthString(topic.elements.date.value)))]), _vm._v(" "), _c('span', {
      staticClass: "topic-name"
    }, [_vm._v(_vm._s(topic.elements.title.value))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(topic.elements.subtitle.value))])])])
  }), 0) : _vm._e()])]) : _vm._e()] : _vm._e(), _vm._v(" "), (
    _vm.inclusionDetail.elements != undefined &&
    _vm.inclusionDetail.elements.bs_background.value[0] != undefined
  ) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section breakthrough",
    style: (_vm.setBackgroundImage(_vm.inclusionDetail.elements.bs_background.value[0].url))
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.bs_description.value)
    }
  }), _vm._v(" "), (
    _vm.inclusionDetail.elements.bs_url != undefined &&
    _vm.inclusionDetail.elements.bs_url.value != ''
  ) ? [_c('a', {
    staticClass: "btn_orange",
    attrs: {
      "href": _vm.inclusionDetail.elements.bs_url.value,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.inclusionDetail.elements.bs_button_label.value))])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.inclusionDetail.elements) ? [(_vm.inclusionDetail.elements.team_headline.value) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section team-container"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.inclusionDetail.elements.team_headline.value) + "\n        ")]), _vm._v(" "), (_vm.inclusionDetail.elements.team_description.value) ? _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.inclusionDetail.elements.team_description.value)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "team"
  }, _vm._l((_vm.team), function(box, index) {
    return _c('div', {
      key: index,
      staticClass: "box-member",
      attrs: {
        "id": 'c' + index
      }
    }, [_c('div', {
      staticClass: "inner",
      style: (_vm.putInOrder(box.image.value[0].url))
    }, [_c('div', {
      staticClass: "overlay",
      style: (_vm.backgroundRGB(box.color.value))
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(box.name.value))]), _vm._v(" "), _c('span', {
      staticClass: "position"
    }, [_vm._v(_vm._s(box.position.value))]), _vm._v(" "), _c('span', {
      staticClass: "bio"
    }, [_vm._v(_vm._s(box.bio.value))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": box.image.value[0].url,
        "alt": box.image.value[0].name
      }
    })])])
  }), 0)])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-works col-xs-12 no-gutters"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center container-fluid"
  }, [_vm._v("Case Studies")]), _vm._v(" "), _c('p', {
    staticClass: "related container"
  }, [_vm._v("\n        Big ideas drive innovation and are essential in engaging customers. Big ideas\n        need big execution, too. That’s why our team is organized and focused on the\n        four areas innovative companies need most:\n      ")]), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.relatedWorks,
      "boxlimit": 3,
      "showViewAll": true
    }
  })], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles insights"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Insights, Commentary and News")]), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.relatedArticles,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showCategory": true,
      "showViewAll": true
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88198004","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/InclusionSections.vue
// module id = 1543
// module chunks = 0